import Joi from '@hapi/joi'

export const DivisionWiseCropDetailsReportObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name is required`,
        "any.required": `Group Name is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity Name").messages({
        "any.invalid": `Operation Entity is required`,
        "any.required": `Operation Entity is required`
    }),
    month: Joi.string().invalid("").label("Month").required().messages({
        "any.invalid": `Please select Month`,
        "any.required": `Month is required`
    }),
}